import { useFormik } from 'formik';
import * as Yup from 'yup';

export const useFacilityProviderForm = ({ practice, onSubmit, validate }) => {
  const schema = Yup.object().shape({
    practice_id: Yup.number().required('Practice is required'),
    facility_name: Yup.string().required('Facility name is required.'),
    facility_npi: Yup.string(),
    facility_id: Yup.string().matches(/^\d+$/, 'Facility Atypical Id must contain only numbers.'),
    facility_addr_1: Yup.string().required('Address line one is required.'),
    facility_addr_2: Yup.string().required(
      'Address line two is required, type N/A if not applicable.'
    ),
    facility_city: Yup.string().required('City is required'),
    facility_state: Yup.string().required('State is required'),
    facility_zip: Yup.string()
      .min(9, 'Too Short!')
      .max(9, 'Too Long!')
      .required('Zip code is required (9 digits)'),
    facility_phone: Yup.string().matches(/^\d+$/, 'Phone must contain only numbers.')
  });

  return useFormik({
    enableReinitialize: true,
    initialValues: {
      id: null,
      practice_id: practice?.id,
      facility_name: practice?.name,
      facility_npi: '',
      facility_id: '',
      facility_addr_1: practice?.practiceAddress?.address_ln_1,
      facility_addr_2: practice?.practiceAddress?.address_ln_2,
      facility_city: practice?.practiceAddress?.city,
      facility_state: practice?.practiceAddress?.state,
      facility_zip: practice?.practiceAddress?.zip.replace(/-/g, ''),
      practitioner_ids: []
    },
    validationSchema: validate ? schema : undefined,
    onSubmit
  });
};
